import React from 'react';
import { Modal } from '@material-ui/core';

interface InModalProps {
  renderInModal: boolean;
}
export const InModal: React.FC<InModalProps> = ({ renderInModal, children }) =>
  renderInModal ? (
    <Modal open={true}>
      <>{children}</>
    </Modal>
  ) : (
    <>{children}</>
  );
